/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"
import * as wjcCore from "@grapecity/wijmo"

import React, { useContext, useEffect, useState } from "react"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import LocalAlertComponent from "../../../components/LocalAlertComponent"
import { TModalTypes, ModalOuter } from "../../../components/Modal/ModalOuter"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import Spinner from "../../../components/Spinner"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { showInfoToast } from "../../../components/CustomToast"
import ComboBox from "../../../components/ComboBox"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { T支払先 } from "../../../components/ComboBox/SiharaiSakiComboBox"
import TextInput from "../../../components/InputWrapper/TextInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import { e支払先区分 } from "../../../constant/enum/master"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import { e点検整備区分 } from "../../../constant/enum/syaryo"
// import dayjs from "dayjs"
import KubunService from "../../../service/master/kubun/kubunService"
import SiharaisakiService from "../../../service/master/siharaisaki/siharaisakiService"
import TenkenService from "../../../service/truck/tenken/tenkenService"
import SyaryoService from "../../../service/truck/syaryoService"
import { TApiResponse } from "../../../service/TApiResponse"
import { FunctionContext } from "../../../components/Context"
import Decimal from "decimal.js"
import SyohizeiKanriService from "../../../service/master/syohizeiKanri/syohizeiKanriService"
import dayjs from "dayjs"
import { 区分マスタ } from "../../../service/master/kubun/TKubun"
import dateUtil from "../../../ts/util/dateUtil"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import RequiredMark from "../../../components/RequiredMark"

//#region [type]
// DefaultCombo
// オイルエレメント交換
export type Tオイルエレメント交換 = { name: string; value: any }
// タイヤ交換
export type Tタイヤ交換 = { name: string; value: any }
// その他整備
export type Tその他整備 = { name: string; value: any }
// 点検整備区分並び替え
export type T点検整備区分並び替え = { name: string; value: any }

// 点検整備区分並び替え用
const 点検整備区分並び替えリスト: T点検整備区分並び替え[] = [
  {
    name: "自主点検",
    value: e点検整備区分.自主点検,
  },
  {
    name: "事故修繕費",
    value: e点検整備区分.事故修繕,
  },
  {
    name: "整備費",
    value: e点検整備区分.整備,
  },
  {
    name: "法令点検（ 3ヶ月）",
    value: e点検整備区分.法令点検_３ヶ月,
  },
  {
    name: "法令点検（車検）",
    value: e点検整備区分.法令点検_車検,
  },
]
//#endregion

//#region dummyData

// defaultComboBox用
const オイルエレメント交換List: Tオイルエレメント交換[] = [
  {
    name: "なし",
    value: 0,
  },
  {
    name: "あり",
    value: 1,
  },
]
const タイヤ交換List: Tタイヤ交換[] = [
  {
    name: "なし",
    value: 0,
  },
  {
    name: "あり",
    value: 1,
  },
]
const その他整備List: Tその他整備[] = [
  {
    name: "なし",
    value: 0,
  },
  {
    name: "あり",
    value: 1,
  },
]
//#endregion

/**
 * 点検整備入力モーダル
 * 点検整備入力,点検整備費用入力の兼用
 * @param {*} props
 * @return {*} reactNode
 */
const TenkenSeibiModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title: string
    footer?: React.ReactNode
    車輌Id: number
    車輌点検整備id?: number
    予定年月?: string
    実施年月?: string
    ListModalIsShow?: (value: boolean) => unknown
    modalType: "点検整備" | "点検整備費用"
    初期表示用点検整備区分コード?: string | null
  }
> = (props) => {
  //#region [method]

  const beforeSubmit = () => {
    set点検整備名区分IsInValid(false)
    // 点検整備区分は必須
    if (wjcCore.isNullOrWhiteSpace(点検整備名区分コード ?? "")) {
      set点検整備名区分IsInValid(true)
      setAlertSource({
        warns: ["点検整備名は必須項目です。"],
      })
      return
    }

    setIsConfirmModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      // TODO:金額計算を確認。Decimal.js??
      let data = {
        車輌ID: props.車輌Id,
        点検整備区分コード: 点検整備名区分コード ?? "",
        点検整備予定日: 整備予定日 ?? "",
        点検整備実施日: 整備実施日 ?? "",
        請求年月: dateUtil.format(請求年月, "YYYY/MM/1"),
        オイルエレメント交換フラグ: オイルエレメント交換コード ? 1 : 0,
        タイヤ交換フラグ: タイヤ交換コード ? 1 : 0,
        その他整備フラグ: その他整備コード ? 1 : 0,
        メーター数値: メーター数値 ?? "",
        // 以下タイヤサイズ、タイヤ種類区分コード、タイヤメーカー区分コードは
        // タイヤ交換フラグがONの時のみ適用する
        タイヤサイズ: タイヤ交換コード ? タイヤサイズ ?? "" : "",
        タイヤ種類区分コード: タイヤ交換コード ? タイヤ種類区分コード ?? "" : "",
        タイヤ費用: タイヤ費用 ?? 0,
        点検整備費: 整備費用 ?? 0,
        その他費用: その他費用 ?? 0,
        その他費用非課税: その他費用非課税 ?? 0,
        消費税: 消費税 ?? 0,
        // 重量税、自動車税は「車検」の時のみ適用する
        重量税: 点検整備名区分コード === e点検整備区分.法令点検_車検 ? 重量税 ?? 0 : 0,
        自動車税: 点検整備名区分コード === e点検整備区分.法令点検_車検 ? 自動車税 ?? 0 : 0,
        支払先コード: 整備業者区分コード ?? "",
        備考: 備考 ?? "",
        費用備考: 費用備考 ?? "",
        削除フラグ: 削除フラグ,
        更新日時: 更新日時 ?? "",
      }

      const service = new TenkenService()
      let res: TApiResponse<boolean>

      if (props.車輌点検整備id) {
        // 更新
        res = await service.put(props.車輌点検整備id, data)
      } else {
        // 登録
        res = await service.post(data)
      }

      setAlertSource(res)
      if (res) {
        props.setIsShow(false)
        if (props.ListModalIsShow) {
          props.ListModalIsShow(false)
        }
        showInfoToast(`点検整備情報の${props.車輌点検整備id ? "更新" : "登録"}が完了しました。`)
        // 元画面の検索
        pageSearch()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  const getSyaryoData = async (id: number) => {
    const service = new SyaryoService()

    try {
      const res = await service.get(id)
      if (res.data) {
        // 車輌の情報
        set車番(res.data.車番)
        set登録地域(res.data.登録番号地域)
        set登録分類(res.data.登録番号分類)
        set登録記号(res.data.登録番号記号)
        set登録指定番号(res.data.登録番号指定番号)
        set車検満了日(res.data.車検満了日)
        set廃車予定日(res.data.廃車予定年月)
        setシリアルNo(res.data.シリアルNO)
        set車台番号(res.data.車台番号)
        set原動機(res.data.原動機有無フラグ ? "有" : "無")
        setメーカー車名(res.data.メーカー車名)
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
    }
  }

  const getData = async (id: number, signal: AbortSignal) => {
    const service = new TenkenService()

    try {
      const res = await service.get(id, signal)
      if (res.data) {
        // 点検整備の情報
        set整備予定日(res.data.点検整備予定日)
        set整備実施日(res.data.点検整備実施日)
        set請求年月(res.data.請求年月)
        setメーター数値(res.data.メーター数値)
        setタイヤサイズ(res.data.タイヤサイズ)
        set備考(res.data.備考)
        set費用備考(res.data.費用備考)

        setタイヤ費用(res.data?.タイヤ費用 ?? 0)
        set重量税(res.data?.重量税 ?? 0)
        set自動車税(res.data?.自動車税 ?? 0)
        set整備費用(res.data?.点検整備費 ?? 0)
        setその他費用(res.data?.その他費用 ?? 0)
        setその他費用非課税(res.data?.その他費用非課税 ?? 0)

        set点検整備名区分コード(res.data.車輌点検整備区分コード)
        set整備業者区分コード(res.data.支払先コード)
        setオイルエレメント交換コード(res.data.オイルエレメント交換フラグ)
        setタイヤ交換コード(res.data.タイヤ交換フラグ)
        setその他整備コード(res.data.その他整備フラグ)
        setタイヤ種類区分コード(res.data.タイヤ種類区分コード)

        set削除フラグ(res.data.削除フラグ)
        set更新日時(res.data.更新日時)
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
    }
  }

  //#endregion

  //#region [state]

  // 検索用
  const pageSearch = useContext(FunctionContext)

  // 点検整備、経費で共通
  const [車番, set車番] = useState<string>()
  const [登録地域, set登録地域] = useState<string>()
  const [登録分類, set登録分類] = useState<string>()
  const [登録記号, set登録記号] = useState<string>()
  const [登録指定番号, set登録指定番号] = useState<string>()
  const [整備予定日, set整備予定日] = useState<string | null>()
  const [整備実施日, set整備実施日] = useState<string | null>()
  const [請求年月, set請求年月] = useState<string | null>()
  const [メーター数値, setメーター数値] = useState<string>()
  const [タイヤサイズ, setタイヤサイズ] = useState<string>()
  const [車検満了日, set車検満了日] = useState<string | null>()
  const [原動機, set原動機] = useState<string>()
  const [メーカー車名, setメーカー車名] = useState<string>()

  // 整備用
  const [備考, set備考] = useState<string>("")
  const [廃車予定日, set廃車予定日] = useState<string | null>()

  // 経費用
  const [シリアルNo, setシリアルNo] = useState<string>()
  const [車台番号, set車台番号] = useState<string>()
  const [費用備考, set費用備考] = useState<string>("")
  const [タイヤ費用, setタイヤ費用] = useState<number>()
  const [重量税, set重量税] = useState<number>()
  const [自動車税, set自動車税] = useState<number>()
  const [整備費用, set整備費用] = useState<number>()
  const [その他費用, setその他費用] = useState<number>()
  const [その他費用非課税, setその他費用非課税] = useState<number>()
  const [税額計算, set税額計算] = useState(false)
  // TODO:消費税はAPIで取得
  const [消費税, set消費税] = useState<number>()
  const [消費税率, set消費税率] = useState<number>()
  const [整備費用合計, set整備費用合計] = useState<number>()

  const [削除フラグ, set削除フラグ] = useState<number>(0)
  const [更新日時, set更新日時] = useState<string>()
  // ComboBoxState
  // 点検整備名
  const [点検整備名区分コード, set点検整備名区分コード] = useState<string | null>()
  const [, set点検整備名区分] = useState<T区分マスタ | null>()
  const [点検整備名区分ItemSource, set点検整備名区分ItemSource] = useState<T区分マスタ[]>()
  const [点検整備名区分ComboBox, set点検整備名区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [点検整備名区分IsLoadEnded, set点検整備名区分IsLoadEnded] = useState<boolean>(false)
  const [点検整備名区分IsInValid, set点検整備名区分IsInValid] = useState<boolean>(false)

  // 整備業者　※ 整備業者でfilterする
  const [整備業者区分コード, set整備業者区分コード] = useState<string | null>()
  const [, set整備業者区分] = useState<T支払先 | null>()
  const [整備業者区分ItemSource, set整備業者区分ItemSource] = useState<T支払先[]>()
  const [整備業者区分ComboBox, set整備業者区分ComboBox] = useState<TWijmoComboBox<
    T支払先["支払先区分コード"],
    T支払先
  > | null>(null)
  const [整備業者区分コードIsLoadEnded, set整備業者区分IsLoadEnded] = useState<boolean>(false)

  // オイルエレメント交換
  const [オイルエレメント交換コード, setオイルエレメント交換コード] = useState<number>()
  const [, setオイルエレメント交換] = useState<Tオイルエレメント交換 | null>()
  const [オイルエレメント交換ComboBox, setオイルエレメント交換ComboBox] = useState<TWijmoComboBox<
    number,
    Tオイルエレメント交換
  > | null>(null)
  const [オイルエレメント交換IsLoadEnded, setオイルエレメント交換IsLoadEnded] = useState<boolean>(false)
  const [オイルエレメント交換ItemSource, setオイルエレメント交換ItemSource] = useState<Tオイルエレメント交換[]>()

  // タイヤ交換
  const [タイヤ交換コード, setタイヤ交換コード] = useState<number>()
  const [, setタイヤ交換] = useState<Tタイヤ交換 | null>()
  const [タイヤ交換ComboBox, setタイヤ交換ComboBox] = useState<TWijmoComboBox<number, Tタイヤ交換> | null>(null)
  const [タイヤ交換IsLoadEnded, setタイヤ交換IsLoadEnded] = useState<boolean>(false)
  const [タイヤ交換ItemSource, setタイヤ交換ItemSource] = useState<Tタイヤ交換[]>()

  // その他整備
  const [その他整備コード, setその他整備コード] = useState<number>()
  const [, setその他整備] = useState<Tその他整備 | null>()
  const [その他整備ComboBox, setその他整備ComboBox] = useState<TWijmoComboBox<number, Tその他整備> | null>(null)
  const [その他整備IsLoadEnded, setその他整備IsLoadEnded] = useState<boolean>(false)
  const [その他整備ItemSource, setその他整備ItemSource] = useState<Tその他整備[]>()
  // タイヤ種類
  const [タイヤ種類区分コード, setタイヤ種類区分コード] = useState<string | null>()
  const [, setタイヤ種類区分] = useState<T区分マスタ | null>()
  const [タイヤ種類区分ItemSource, setタイヤ種類区分ItemSource] = useState<T区分マスタ[]>()
  const [タイヤ種類区分ComboBox, setタイヤ種類区分ComboBox] = useState<TWijmoComboBox<
    T区分マスタ["区分コード"],
    T区分マスタ
  > | null>(null)
  const [タイヤ種類区分IsLoadEnded, setタイヤ種類区分IsLoadEnded] = useState<boolean>(false)

  // init
  const [isComponentInit, setIsComponentInit] = useState(false)
  const [initialDataSetFlag, setInitialDataSetFlag] = useState(false)

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(true)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  //#endregion

  //#region [effect]
  // componentチェック
  useEffect(() => {
    setAlertSource(undefined)

    // componentチェック
    if (!点検整備名区分ComboBox) return
    if (!整備業者区分ComboBox) return
    if (!オイルエレメント交換ComboBox) return
    if (!タイヤ交換ComboBox) return
    if (!その他整備ComboBox) return
    if (!タイヤ種類区分ComboBox) return

    if (!isComponentInit) setIsComponentInit(true)
  }, [
    isComponentInit,
    点検整備名区分ComboBox,
    整備業者区分ComboBox,
    オイルエレメント交換ComboBox,
    タイヤ交換ComboBox,
    その他整備ComboBox,
    タイヤ種類区分ComboBox,
  ])

  useEffect(() => {
    if (!isComponentInit) return

    if (props.isShow) {
      // ComboItemSource
      Promise.all([new KubunService().getList(), new SiharaisakiService().getList({})]).then(
        ([区分マスタRes, 支払先Res]) => {
          // 区分並び替え
          let 点検整備区分OrderList: 区分マスタ[] = []

          点検整備区分並び替えリスト.forEach((コード) => {
            let データ = 区分マスタRes.data
              .filter((d) => d.分類コード === "C0005")
              .find((d) => d.区分コード === コード.value)
            if (データ) {
              点検整備区分OrderList.push(データ)
            }
          })

          set点検整備名区分ItemSource(点検整備区分OrderList)
          set整備業者区分ItemSource(支払先Res.data)
          setタイヤ種類区分ItemSource(区分マスタRes.data)
          // flag
          setオイルエレメント交換ItemSource(オイルエレメント交換List)
          setタイヤ交換ItemSource(タイヤ交換List)
          setその他整備ItemSource(その他整備List)

          setInitialDataSetFlag(true)
        }
      )
    } else {
      // 非表示時に中身を空にして閉じる
      set車番("")
      set登録地域("")
      set登録分類("")
      set登録記号("")
      set登録指定番号("")
      set車検満了日("")
      set廃車予定日("")
      set整備予定日("")
      set整備実施日("")
      set請求年月("")
      setメーター数値("")
      setタイヤサイズ("")
      setシリアルNo("")
      set車台番号("")
      set費用備考("")
      set備考("")
      set原動機("")
      setメーカー車名("")

      // MEMO: wijmoのNumberコンポーネントの仕様に引っかかるので0で初期化
      setタイヤ費用(0)
      set重量税(0)
      set自動車税(0)
      set整備費用(0)
      setその他費用(0)
      setその他費用非課税(0)
      set消費税(0)
      set整備費用合計(0)

      set点検整備名区分コード("")
      set整備業者区分コード("")
      setオイルエレメント交換コード(undefined)
      setタイヤ交換コード(undefined)
      setその他整備コード(undefined)
      setタイヤ種類区分コード("")
      set点検整備名区分IsInValid(false)

      set削除フラグ(0)
      set更新日時("")
      setInitialDataSetFlag(false)
      setIsSpinnerShow(true)
    }
  }, [props.isShow, isComponentInit])

  useEffect(() => {
    if (initialDataSetFlag) {
      const abortController = new AbortController()
      if (props.車輌点検整備id) {
        Promise.all([getSyaryoData(props.車輌Id), getData(props.車輌点検整備id, abortController.signal)]).then(() => {
          setInitialDataSetFlag(false)
          setIsSpinnerShow(false)

          set税額計算(true)
        })
      } else {
        // 新規の場合
        Promise.all([getSyaryoData(props.車輌Id)]).then(() => {
          // TODO: MEMO: カレンダークリックから編集する予定日のみ、とりあえず設定する。
          set整備予定日(props.予定年月)
          setInitialDataSetFlag(false)
          setIsSpinnerShow(false)
          set点検整備名区分コード(props.初期表示用点検整備区分コード ?? "")
        })
      }
    }
  }, [initialDataSetFlag])

  useEffect(() => {
    // 日付が無い場合、消費税率を０にする
    if (!dayjs(整備実施日).isValid()) {
      // set消費税率(0)
      return
    }

    Promise.all([
      new SyohizeiKanriService().getList({
        適用日: dayjs(整備実施日).format("YYYY/MM/DD"),
      }),
    ]).then(([消費税管理Res]) => {
      // 消費税率は必ず１件のみ存在する前提だが、取得できない場合は消費税率を初期化する
      if (消費税管理Res.data.length === 0) {
        set消費税率(0)
        return
      }
      消費税管理Res.data.forEach((x) => {
        const m消費税率 = new Decimal(x.消費税率 ?? 0)
        // 百分率の計算用に100で割った値をセットする
        set消費税率(m消費税率.div(100).toNumber())
      })
    })
  }, [整備実施日])

  useEffect(() => {
    if (税額計算) {
      // 整備費用、消費税率ともに存在する場合、消費税を算出
      const d整備費用 = new Decimal(整備費用 ?? 0)
      const dその他費用 = new Decimal(その他費用 ?? 0)
      const dその他費用非課税 = new Decimal(その他費用非課税 ?? 0)
      const d費用 = d整備費用.plus(dその他費用)
      const d消費税率 = new Decimal(消費税率 ?? 0)

      // 税込額から消費税計算、小数点切り捨てでセット
      // const d消費税百分率 = new Decimal(d消費税率.times(100) ?? 0)
      // const d割り戻し = d消費税百分率.plus(100)
      // set消費税(
      //   Math.floor(d費用.times(d消費税百分率).div(d割り戻し).toNumber())
      // )
      // 税抜額から消費税計算、小数点切り捨てでセット
      const d消費税額 = Math.floor(d費用.times(d消費税率).toNumber())
      set消費税(d消費税額)

      // 合計算出
      set整備費用合計(d費用.plus(dその他費用非課税).plus(d消費税額).toNumber())

      set税額計算(false)
    }
  }, [税額計算])

  //#endregion

  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={
        <>
          <Button
            type="submit"
            variant="waiting"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              beforeSubmit()
            }}>
            {props.車輌点検整備id ? `更新` : `登録`}
          </Button>
          {props.車輌点検整備id && (
            <Button
              type="submit"
              variant="caution"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                set削除フラグ(1)
                beforeSubmit()
              }}>
              削除
            </Button>
          )}
        </>
      }>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid className="label-form">
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-6rem">車番</th>
                    <td>
                      <TextInput
                        style={{ width: "5rem" }}
                        id="車番"
                        name="車番"
                        value={車番}
                        isReadOnly={true}
                        setValue={set車番}
                      />
                    </td>
                    <th className="min-w-6rem">登録番号</th>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "7rem" }}
                          id="登録地域"
                          name="登録地域"
                          value={登録地域}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                        <TextInput
                          style={{ width: "5rem" }}
                          id="登録分類"
                          name="登録分類"
                          value={登録分類}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                        <TextInput
                          style={{ width: "4rem" }}
                          id="登録記号"
                          name="登録記号"
                          value={登録記号}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                        <TextInput
                          style={{ width: "5rem" }}
                          id="登録指定番号"
                          name="登録指定番号"
                          value={登録指定番号}
                          isReadOnly={true}
                          setValue={() => {}}
                        />
                      </div>
                    </td>
                    <th className="min-w-6rem">原動機</th>
                    <td>
                      <TextInput
                        style={{ width: "5rem" }}
                        id="原動機"
                        name="原動機"
                        isReadOnly={true}
                        value={原動機}
                        setValue={set原動機}
                      />
                    </td>
                    <th className="min-w-6rem">メーカー車名</th>
                    <td>
                      <TextInput
                        style={{ width: "15rem" }}
                        id="メーカー車名"
                        name="メーカー車名"
                        isReadOnly={true}
                        value={メーカー車名}
                        setValue={setメーカー車名}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-6rem">シリアルNO</th>
                    <td>
                      {props.modalType === "点検整備費用" && (
                        <TextInput
                          style={{ width: "10rem" }}
                          id="シリアルNo"
                          name="シリアルNo"
                          isReadOnly={true}
                          value={シリアルNo}
                          setValue={setシリアルNo}
                        />
                      )}
                    </td>
                    <th className="min-w-6rem">車台番号</th>
                    <td>
                      <TextInput
                        style={{ width: "15rem" }}
                        id="車台番号"
                        name="車台番号"
                        isReadOnly={true}
                        value={車台番号}
                        setValue={set車台番号}
                      />
                    </td>
                    <th className="min-w-6rem">車検満了日</th>
                    <td>
                      <div className="w-10rem">
                        <DateInput
                          id="車検満了日"
                          isReadOnly
                          value={車検満了日}
                          setValue={(v) => {
                            set車検満了日(v)
                          }}></DateInput>
                      </div>
                    </td>
                    <th className="min-w-6rem">廃車予定日</th>
                    <td>
                      <div className="w-10rem">
                        <DateInput id="廃車予定日" isReadOnly value={廃車予定日} setValue={() => {}}></DateInput>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-12rem">整備予定日</th>
                    <td>
                      <div className="w-10rem">
                        <DateInput
                          id="整備予定日"
                          isReadOnly={props.modalType === "点検整備費用"}
                          value={整備予定日}
                          setValue={(v) => {
                            set整備予定日(v)
                          }}></DateInput>
                      </div>
                    </td>
                    <th className="min-w-10rem">整備実施日</th>
                    <td>
                      <div className="w-10rem">
                        <DateInput
                          id="整備実施日"
                          isReadOnly={props.modalType === "点検整備"}
                          value={整備実施日}
                          setValue={(v) => {
                            set整備実施日(v)
                          }}></DateInput>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-12rem">
                      点検整備名
                      {props.modalType === "点検整備" && <RequiredMark />}
                    </th>
                    <td>
                      <ComboBox.Kubun
                        分類コード="C0005"
                        isReadOnly={props.modalType === "点検整備費用"}
                        itemsSource={点検整備名区分ItemSource}
                        isEmpty
                        isLoadEnded={点検整備名区分IsLoadEnded}
                        setIsLoadEnded={set点検整備名区分IsLoadEnded}
                        setSelectedValue={set点検整備名区分コード}
                        selectedValue={点検整備名区分コード}
                        setSelectedItem={set点検整備名区分}
                        ComboBox={点検整備名区分ComboBox}
                        className={点検整備名区分IsInValid ? "is-error" : ""}
                        setComboBox={set点検整備名区分ComboBox}></ComboBox.Kubun>
                    </td>
                    <th className="min-w-6rem">メーター数値</th>
                    <td>
                      <TextInput
                        style={{ width: "10rem" }}
                        isReadOnly={props.modalType === "点検整備費用"}
                        id="メーター数値"
                        name="メーター数値"
                        value={メーター数値}
                        setValue={setメーター数値}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-12rem">整備業者</th>
                    <td>
                      <div className="w-25rem">
                        <ComboBox.SiharaiSaki
                          isRequired={false}
                          isEmpty
                          siharaiSaki={e支払先区分.整備会社}
                          isLoadEnded={整備業者区分コードIsLoadEnded}
                          setIsLoadEnded={set整備業者区分IsLoadEnded}
                          itemsSource={整備業者区分ItemSource}
                          selectedValue={整備業者区分コード}
                          setSelectedItem={set整備業者区分}
                          setSelectedValue={(v) => {
                            set整備業者区分コード(v)
                          }}
                          ComboBox={整備業者区分ComboBox}
                          setComboBox={set整備業者区分ComboBox}></ComboBox.SiharaiSaki>
                      </div>
                    </td>
                    <th className="min-w-12rem">請求年月</th>
                    <td>
                      <div className="w-10rem">
                        <MonthInput id="請求年月" value={請求年月} setValue={(v) => set請求年月(v!)} />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-12rem">オイルエレメント交換</th>
                    <td colSpan={8}>
                      <div className="w-10rem">
                        <ComboBox.Default
                          itemsSource={オイルエレメント交換ItemSource}
                          isLoadEnded={オイルエレメント交換IsLoadEnded}
                          setIsLoadEnded={setオイルエレメント交換IsLoadEnded}
                          setSelectedValue={setオイルエレメント交換コード}
                          selectedValue={オイルエレメント交換コード}
                          setSelectedItem={setオイルエレメント交換}
                          ComboBox={オイルエレメント交換ComboBox}
                          setComboBox={setオイルエレメント交換ComboBox}></ComboBox.Default>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-12rem">タイヤ費</th>
                    <td>
                      <div className="w-10rem">
                        <ComboBox.Default
                          itemsSource={タイヤ交換ItemSource}
                          isLoadEnded={タイヤ交換IsLoadEnded}
                          setIsLoadEnded={setタイヤ交換IsLoadEnded}
                          setSelectedValue={setタイヤ交換コード}
                          selectedValue={タイヤ交換コード}
                          setSelectedItem={setタイヤ交換}
                          ComboBox={タイヤ交換ComboBox}
                          setComboBox={setタイヤ交換ComboBox}></ComboBox.Default>
                      </div>
                    </td>
                    <th className="min-w-8rem">タイヤサイズ</th>
                    <td>
                      <TextInput
                        isReadOnly={タイヤ交換コード === 0}
                        style={{ width: "10rem" }}
                        id="タイヤサイズ"
                        name="タイヤサイズ"
                        value={タイヤサイズ}
                        setValue={setタイヤサイズ}
                      />
                    </td>
                    <th className="min-w-8rem">タイヤ種類</th>
                    <td>
                      <div className="w-10rem">
                        <ComboBox.Kubun
                          isReadOnly={タイヤ交換コード === 0}
                          分類コード="C0006"
                          itemsSource={タイヤ種類区分ItemSource}
                          isLoadEnded={タイヤ種類区分IsLoadEnded}
                          setIsLoadEnded={setタイヤ種類区分IsLoadEnded}
                          setSelectedValue={setタイヤ種類区分コード}
                          selectedValue={タイヤ種類区分コード}
                          setSelectedItem={setタイヤ種類区分}
                          ComboBox={タイヤ種類区分ComboBox}
                          setComboBox={setタイヤ種類区分ComboBox}></ComboBox.Kubun>
                      </div>
                    </td>
                    {/* <th className="min-w-8rem">タイヤ費用</th>
                    <td>
                      <div className="input-group w-8rem">
                        <wjrInput.InputNumber
                          isReadOnly={タイヤ交換コード === 0}
                          id="タイヤ費用"
                          name="タイヤ費用"
                          format="N0"
                          value={タイヤ費用}
                          valueChanged={(c: wjcInput.InputNumber, e: any) => {
                            c.value != null
                              ? setタイヤ費用(c.value)
                              : setタイヤ費用(undefined)
                          }}
                        />
                      </div>
                    </td>
                    <td className="form-label-right">円</td> */}
                  </tr>
                  <tr>
                    <th className="min-w-12rem">その他整備</th>
                    <td>
                      <div className="w-10rem">
                        <ComboBox.Default
                          itemsSource={その他整備ItemSource}
                          isLoadEnded={その他整備IsLoadEnded}
                          setIsLoadEnded={setその他整備IsLoadEnded}
                          setSelectedValue={setその他整備コード}
                          selectedValue={その他整備コード}
                          setSelectedItem={setその他整備}
                          ComboBox={その他整備ComboBox}
                          setComboBox={setその他整備ComboBox}></ComboBox.Default>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
          <br />

          {/* 点検費用の場合のみ表示 start */}
          {props.modalType === "点検整備費用" && (
            <>
              <Row>
                <Col>
                  <Table className="form-table">
                    <tbody>
                      <tr>
                        <th className="min-w-12rem">重量税</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              isReadOnly={点検整備名区分コード !== e点検整備区分.法令点検_車検}
                              id="重量税"
                              name="重量税"
                              format="N0"
                              value={重量税}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? set重量税(c.value) : set重量税(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right">円</td>
                        <th className="min-w-10rem">自動車税</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              isReadOnly={点検整備名区分コード !== e点検整備区分.法令点検_車検}
                              id="自動車税"
                              name="自動車税"
                              format="N0"
                              value={自動車税}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? set自動車税(c.value) : set自動車税(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right">円</td>
                      </tr>
                      <tr>
                        <th className="min-w-10rem">整備費用（税抜）</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              id="整備費用"
                              name="整備費用"
                              format="N0"
                              value={整備費用}
                              lostFocus={() => {
                                set税額計算(true)
                              }}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? set整備費用(c.value) : set整備費用(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right" colSpan={4}>
                          円
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-10rem">その他費用（税抜）</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              id="その他費用"
                              name="その他費用"
                              format="N0"
                              value={その他費用}
                              lostFocus={() => {
                                set税額計算(true)
                              }}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? setその他費用(c.value) : setその他費用(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right" colSpan={4}>
                          円
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-10rem">その他費用（非課税）</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              id="その他費用非課税"
                              name="その他費用非課税"
                              format="N0"
                              value={その他費用非課税}
                              lostFocus={() => {
                                set税額計算(true)
                              }}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? setその他費用非課税(c.value) : setその他費用非課税(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right" colSpan={4}>
                          円
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-10rem">消費税</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              isReadOnly={true}
                              id="消費税"
                              name="消費税"
                              format="N0"
                              value={消費税}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? set消費税(c.value) : set消費税(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right" colSpan={4}>
                          円&nbsp;（整備費用+その他費用）×税率
                        </td>
                      </tr>
                      <tr>
                        <th className="min-w-10rem">整備費用合計（税込）</th>
                        <td>
                          <div className="input-group w-8rem">
                            <wjrInput.InputNumber
                              isReadOnly={true}
                              id="整備費用合計"
                              name="整備費用合計"
                              format="N0"
                              value={整備費用合計}
                              valueChanged={(c: wjcInput.InputNumber, e: any) => {
                                c.value != null ? set整備費用合計(c.value) : set整備費用合計(undefined)
                              }}
                            />
                          </div>
                        </td>
                        <td className="form-label-right" colSpan={4}>
                          円
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <br />
            </>
          )}
          {/* 点検費用の場合のみ表示 end */}

          <Row>
            <Col>
              <Table className="form-table">
                <tbody>
                  <tr>
                    <th className="min-w-12rem">備考</th>
                    <td>
                      <TextAreaInput
                        isReadOnly={props.modalType === "点検整備費用"}
                        style={{ width: "50rem" }}
                        id="備考"
                        name="備考"
                        value={備考}
                        setValue={set備考}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th className="min-w-12rem">費用備考</th>
                    <td>
                      <TextAreaInput
                        isReadOnly={props.modalType === "点検整備"}
                        style={{ width: "50rem" }}
                        id="費用備考"
                        name="費用備考"
                        value={費用備考}
                        setValue={set費用備考}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </form>
      </Container>
      <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </ModalOuter>
  )
}

export default TenkenSeibiModal
